import { createFileRoute } from '@tanstack/react-router'

import { ShowAddresses } from '@repo/common/components/ShowAddresses'

export const Route = createFileRoute('/_app/addresses')({
  component: ShowAddresses,
})
